import { useMutation } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { getButterflyConnectionQueryKey } from './get-butterfly-connection'

type UpdateButterflyConnectionRequest = {
  authorizationCode: string
  buildingId: number
  config: {
    shouldAutoAssignApartmentDoorVisitor: boolean
    visitorPermissionDoors: { id: string; name: string }[]
  }
}

const updateButterflyConnection = async (data: UpdateButterflyConnectionRequest) => {
  const response = await integrationAPI.post('/butterfly/connect-building', data)
  return response.data
}

export const useUpdateButterflyConnection = () =>
  useMutation({
    mutationFn: updateButterflyConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getButterflyConnectionQueryKey({ buildingId: variables.buildingId })])
    },
  })
